/**
 * Shared in-flight /api/homepage/layout fetch so HomePage flag probe and
 * HomePageSearchFirst content load do not double-hit the API on cold boot.
 */

export type HomepageLayoutResponse = {
  success?: boolean;
  data?: {
    searchFirstEnabled?: boolean;
    visibility?: Record<string, boolean>;
    searchHero?: Record<string, unknown>;
    hostTraining?: Record<string, unknown>;
    pathCards?: { cards?: unknown[]; title?: string; subtitle?: string };
    [key: string]: unknown;
  };
};

let inflight: Promise<HomepageLayoutResponse | null> | null = null;
let cached: HomepageLayoutResponse | null | undefined;

export function loadHomepageLayoutOnce(options?: { force?: boolean }): Promise<HomepageLayoutResponse | null> {
  if (!options?.force && cached !== undefined) {
    return Promise.resolve(cached);
  }
  if (!options?.force && inflight) {
    return inflight;
  }
  inflight = (async () => {
    try {
      const res = await fetch('/api/homepage/layout');
      if (!res?.ok) {
        cached = null;
        return null;
      }
      const json = (await res.json()) as HomepageLayoutResponse;
      cached = json;
      return json;
    } catch {
      cached = null;
      return null;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

/** Test helper — clear module cache between Jest cases. */
export function resetHomepageLayoutOnceCacheForTests(): void {
  inflight = null;
  cached = undefined;
}
